module.exports = __webpack_public_path__ + "static/media/game.d8c8cb83.png";